import { makeStyles } from "tss-react/mui"
import { Box, Typography } from "@mui/material"

import { LocalizedEnum } from "../../../../../../modules/localization/components/AppLocalized"

import type { TakeawayPaymentMethod } from "../takeawayTypes"
import { toEnumKey } from "./takeawayCheckoutLib"
import { TakeawayPaymentMethodIcon } from "./TakeawayPaymentMethodIcon"

const useStyles = makeStyles()((theme) => ({
    row: {
        display: "flex",
        alignItems: "center",
        gap: ".75rem",
        padding: "1rem",
        cursor: "pointer",
        transition: "background 0.15s",
        "&:hover": {
            background: theme.palette.tailwind.slate[50],
        },
    },
    rowSelected: {
        background: theme.palette.tailwind.blue[50],
        "&:hover": {
            background: theme.palette.tailwind.blue[50],
        },
    },
    rowDisabled: {
        opacity: 0.45,
        cursor: "not-allowed",
        "&:hover": {
            background: "transparent",
        },
    },
    info: {
        flex: 1,
        minWidth: 0,
    },
    name: {
        fontWeight: 400,
        color: theme.palette.tailwind.slate[900],
    },
    iconWrap: {
        width: "2.25rem",
        height: "2.25rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        flexShrink: 0,
    },
    iconImg: {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
    },
}))

type TakeawayPaymentOptionProps = Readonly<{
    method: TakeawayPaymentMethod
    isSelected: boolean
    isDisabled: boolean
    nameOverride?: string
    onClick: () => void
}>

export function TakeawayPaymentOption({
    method,
    isSelected,
    isDisabled,
    nameOverride,
    onClick,
}: TakeawayPaymentOptionProps) {
    const { classes, cx } = useStyles()

    return (
        <Box
            className={cx(classes.row, isSelected && classes.rowSelected, isDisabled && classes.rowDisabled)}
            onClick={isDisabled ? undefined : onClick}
        >
            <Box className={classes.info}>
                {nameOverride ? (
                    <Typography variant="body1" className={classes.name}>
                        {nameOverride}
                    </Typography>
                ) : (
                    <LocalizedEnum base="purchases-payment-method" enumValue={toEnumKey(method.value)}>
                        <Typography variant="body1" className={classes.name}>
                            {method.value}
                        </Typography>
                    </LocalizedEnum>
                )}
            </Box>
            <Box className={classes.iconWrap}>
                <TakeawayPaymentMethodIcon method={method} className={classes.iconImg} />
            </Box>
        </Box>
    )
}
